import { BsPaperclip } from 'react-icons/bs';
import { HistoryAttachment, HistoryEntry } from 'types';
import { Modal } from 'components/modal';
import { Text } from 'components/text';
import { formatConsignmentHistoryValue } from 'helpers';
import { FontSize, FontWeight } from 'commons';
import { Attachments } from '../attachments';
import { HistoryCheck } from '../history-check';

const IMAGE_MIME_TYPE = 'image';

type FormattedEntry = {
  content: string;
  attachments: HistoryAttachment[];
};

function formatEntry(entry: HistoryEntry): FormattedEntry {
  const imageAttachments = entry.attachments.filter((attachment) => {
    const { mimeType, url } = attachment;

    const isImage = mimeType.includes(IMAGE_MIME_TYPE);
    const hasUrl = Boolean(url);

    return isImage && hasUrl;
  });

  return {
    content: formatConsignmentHistoryValue(entry),
    attachments: imageAttachments,
  };
}

interface Props {
  entry: HistoryEntry;
  isLast: boolean;
  isDone: boolean;
}

export function HistoryContent({ entry, isLast, isDone }: Props) {
  const { attachments, content } = formatEntry(entry);

  const imageAttachments = attachments.filter((attachment) => {
    const { mimeType, url } = attachment;

    const isImage = mimeType.includes(IMAGE_MIME_TYPE);
    const hasUrl = Boolean(url);

    return isImage && hasUrl;
  });

  const hasAttachments = Boolean(imageAttachments.length);

  return (
    <>
      <Text
        size={FontSize.font12}
        weight={isDone || isLast ? FontWeight.bold : FontWeight.regular}
      >
        {content}
      </Text>

      {hasAttachments && (
        <div className="flex items-center">
          <Modal modalContent={<Attachments attachments={imageAttachments} />}>
            <div className="relative flex items-center">
              <BsPaperclip className="absolute cursor-pointer text-primary-300 hover:opacity-70" />
            </div>
          </Modal>
        </div>
      )}

      {isDone && <HistoryCheck />}
    </>
  );
}
